export const BILL_DAY_OF_MONTH = 10;
